import React, { useEffect, useState } from "react";
import { deriveDemoStage } from "../../features/demo/demoContract";

const controls = [
  ["normal", "Paparan biasa"],
  ["sequence", "Aliran penuh"],
  ["countdown", "Countdown sahaja"],
  ["iqamah", "Iqamah"],
  ["dark", "Skrin gelap"],
];

const stageLabels = {
  normal: "Normal",
  countdown: "Countdown",
  iqamah: "Iqamah",
  dark: "Gelap",
};

const DemoEtvControls = ({ preview = {}, onChange, disabled = false }) => {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (preview.mode !== "sequence") return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), 1_000);
    return () => window.clearInterval(timer);
  }, [preview.mode, preview.startedAt]);
  const current = deriveDemoStage(preview, now);

  return (
    <div className="demo-etv-controls" aria-label="Kawalan paparan ETV">
      <div className="demo-etv-control-heading">
        <strong>Cuba keadaan ETV</strong>
        <span aria-live="polite">
          {stageLabels[current.stage]}
          {current.secondsRemaining > 0 ? ` · ${current.secondsRemaining} saat` : ""}
        </span>
      </div>
      <div className="demo-etv-control-buttons">
        {controls.map(([mode, label]) => (
          <button
            key={mode}
            type="button"
            disabled={disabled}
            aria-pressed={preview.mode === mode}
            onClick={() => onChange(mode)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DemoEtvControls;
